/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Customer } from '@shared/models';

export interface CustomersState {
  customersPartial: Customer[];
  customers: Customer[];
  actionPending: boolean;
}

export const initialState: CustomersState = {
  customersPartial: [],
  customers: [],
  actionPending: false
};
